module.exports = __webpack_public_path__ + "static/media/text_understand_demo.0578b6a6.png";